import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-record-zs",
  "use": "icon-record-zs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-record-zs\"><path d=\"M345.6 460.8h371.2l-179.2 448-192-448z m44.8-160h281.6l51.2 108.8H358.4l32-108.8zM307.2 403.2L83.2 307.2l121.6-89.6 140.8 76.8-38.4 108.8z m-224-38.4l211.2 96 224 441.6-435.2-537.6zM768 454.4l198.4-102.4L550.4 896 768 454.4z m-6.4-51.2L704 288l128-70.4 108.8 89.6-179.2 96zM384 243.2l-44.8-12.8-96-51.2 108.8-38.4h345.6l102.4 44.8-96 51.2-32 6.4H384z m0 0\" p-id=\"20448\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/record-zs.svg
// module id = aAN3
// module chunks = 27